import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import style from './markdown-message.module.sass'

export const MarkdownMessage = ({ content }: { content: string }) => {
	const normalized = content.replace(/<br\s*\/?>/gi, '\n')
	return <div className={style.container}>
								<ReactMarkdown remarkPlugins={[remarkGfm]}>{normalized}</ReactMarkdown>

	</div>
}